__webpack_require__.p = "/shopping/demotivator/";